export const parseSchedule = (sk, sv = null) => {
  let strs = sk.split('-')
  let from = new Date(Number.parseInt(strs[0]))
  let to = new Date(Number.parseInt(strs[1]))
  let quota = null
  let status = null
  if (sv) {
    quota = Number.parseInt(sv.split('-')[0])
    status = Number.parseInt(sv.split('-')[1])
  }
  return {
    from: from,
    to: to,
    id: sk,
    quota: quota,
    status: status,
  }
}
